export const isMatchMobileMedia = () => window.matchMedia('(max-width: 959px)').matches;
